export const reactionsQueryKeys = {
  all: () => ['reactions'],
};
